import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { CreateMerchantComponent } from './create-merchant/create-merchant.component';
import { ListMerchantsComponent } from './list-merchants/list-merchants.component';
import { ReportsComponent } from './reports/reports.component';
import { SignInComponent } from './sign-in/sign-in.component';

const routes: Routes = [
  { path: 'reports', component: ReportsComponent },
  { path: 'sign-in', component: SignInComponent },
  { path: 'merchants/:mid', component: CreateMerchantComponent, canActivate: [AuthGuard] },
  { path: 'merchants', component: ListMerchantsComponent, canActivate: [AuthGuard] },
  { path: 'merchant', component: CreateMerchantComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/merchants', pathMatch: 'full'},
  { path: '**', redirectTo: '/merchants', pathMatch: 'full' } // catch any unfound routes and redirect to home page
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
